import FullScreenLoader from "../../BON Frontend/Booking-Form/Common/FullScreenLoader";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PropertyGuaranteeCodes, SavePropertyGuaranteeCodes } from "../../Services/Service";
import Hearder from "../commun/Hearder"
import SideBar from "../commun/SideBar"
import swal from "sweetalert";
import { deletePropertyGuaranteeCode } from "../../Redux/Slices/Property/slice";

export const GuaranteeCodes = () => {
    const dispatch = useDispatch();
    const deleting = useSelector((state) => state.propertyAgent.deleting);
    const [guaranteeCodes, setGuaranteeCodes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([{ code: "", name: "" }]);

    const fetchGuaranteeCodes = useCallback(async () => {
            setLoading(true);
            try {
                const data = await PropertyGuaranteeCodes();
                if (Array.isArray(data)) setGuaranteeCodes(data);
            } catch (error) {
                console.log("Error fetching gurantee Codes:", error);
            } finally {
                setLoading(false);
            }
    }, []);

    useEffect(() => {
        fetchGuaranteeCodes();
    }, [fetchGuaranteeCodes]);

    const handleDeleteClick = async (id) => {
        const shouldDelete = await swal({ title: "Are you sure?", text: "Once deleted, this guarantee code cannot be recovered.", icon: "warning", buttons: ["Cancel", "Delete"], dangerMode: true });
        if (!shouldDelete) return;
        try {
            const { response } = await dispatch(deletePropertyGuaranteeCode(id)).unwrap();
            await fetchGuaranteeCodes();
            await swal(response?.Message || response?.message || "Guarantee code deleted successfully.", { icon: "success" });
        } catch (error) {
            await swal(error?.Message || error?.message || "Unable to delete guarantee code.", { icon: "error" });
        }
    };

    const handleAddRow = () => {
        setRows([...rows, { code: "", name: "" }]);
    };

    const handleDeleteRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));
    };



    const handleChange = (index, field, value) => {
        const newRows = [...rows];
        newRows[index][field] = value;
        setRows(newRows);
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {

            for (let row of rows) {
                if (!row.code || !row.name) {
                    swal("Please Enter Code and Business Source !", {
                        icon: "warning",
                        buttons: {
                            confirm: { text: "OK", className: "btn btn-warning" },
                        },
                    });
                    setLoading(false);
                    return; // Stop execution
                }
            }
            // Loop through all rows and send each one to the API
            for (let row of rows) {
                const formdata = {
                    ID: 0, // or whatever ID you need
                    Code: row.code,
                    GuaranteeCodes: row.name
                };
                await SavePropertyGuaranteeCodes(formdata);
            }

            swal("Business Source Added successfully", {
                icon: "success",
                buttons: {
                    confirm: { text: "OK", className: "btn btn-success" },
                },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Add-Business-Source")
                );
                modal.hide();
            });

            // Reset rows
            setRows([{ code: "", name: "" }]);

            // Refresh the list
            const data = await PropertyGuaranteeCodes();
            if (Array.isArray(data)) setGuaranteeCodes(data);

        } catch (error) {
            console.log("Error saving Business Source", error);
            alert("Failed to save Business Source");
        } finally {
            setLoading(false);
        }
    };


    const [editData, setEditData] = useState({
        ID: 0,
        Code: "",
        guaranteeCodes: ""
    });


    const handleUpdate = async () => {
        setLoading(true);
        try {
            // Build payload exactly as backend expects (use capitalized key if API needs it)
            const payload = {
                ID: editData.ID,
                Code: editData.Code,
                GuaranteeCodes: editData.guaranteeCodes
            };

            
            await SavePropertyGuaranteeCodes(payload);

            swal("Business Source updated successfully", {
                icon: "success",
                buttons: { confirm: { text: "OK", className: "btn btn-success" } },
            }).then(() => {
                const modal = window.bootstrap.Modal.getInstance(
                    document.getElementById("Update-Business-Source")
                );
                if (modal) modal.hide();
            });

            // Refresh the list and normalize
            const data = await PropertyGuaranteeCodes();
            if (Array.isArray(data)) {
                setGuaranteeCodes(data.map(d => ({
                    ...d,
                    guaranteeCodes: d.GuaranteeCodes ?? d.guaranteeCodes ?? ""
                })));
            }
        } catch (error) {
            console.log("Error updating Business Source", error);
            alert("Failed to update Business Source");
        } finally {
            setLoading(false);
        }
    };



    return (
        <>
            {(loading || deleting) && (
                <FullScreenLoader />
            )}
            <div className="wrapper">
                <SideBar />
                <div className="main-panel">
                    <Hearder />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">

                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-title">Guarantee Codes</h4>
                                        </div>
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <div className="text-end mb-2">
                                                    <button type="button" className="btn btn-primary btn-sm waves-effect waves-light mt-1" data-bs-toggle="modal" data-bs-target="#Add-Business-Source">Add </button>
                                                </div>
                                                <table
                                                    className="display table table-striped table-hover basic-datatables"
                                                >
                                                    <thead>
                                                        <tr>
                                                            <th>Code</th>
                                                            <th>Guarantee Codes</th>
                                                            <th>Action</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {guaranteeCodes && guaranteeCodes.length > 0 ? (
                                                            guaranteeCodes.map((item, index) => (
                                                                <tr key={item.ID || index}>
                                                                    <td>{item.Code}</td>
                                                                    <td>{item.guaranteeCodes}</td>
                                                                    <td>
                                                                        <button type="button" className="btn btn-primary btn-sm waves-effect waves-light py-1 px-2" data-bs-toggle="modal" data-bs-target="#Update-Business-Source"
                                                                            onClick={() => setEditData({
                                                                                ID: item.ID,
                                                                                Code: item.Code,
                                                                                guaranteeCodes: item.GuaranteeCodes || item.guaranteeCodes || ""
                                                                            })}><i className="fas fa-edit"></i></button>
                                                                            <button type="button" className="btn btn-danger btn-sm waves-effect waves-light py-1 px-2" onClick={() => handleDeleteClick(item.ID)} disabled={deleting}><i className="fas fa-trash"></i></button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="3" className="text-center">
                                                                    No data found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* sumbit Business Source modal content */}
                            <div
                                id="Add-Business-Source"
                                className="modal fade"
                                tabIndex={-1}
                                role="dialog"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Add Guarantee Codes</h4>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>
                                        <div className="modal-body" style={{ maxHeight: "460px", overflowY: "auto" }}>
                                            <table className="table table-striped">
                                                <thead>
                                                    <tr>
                                                        <th style={{ width: "152px" }}>Code</th>
                                                        <th>Guarantee Codes</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {rows.map((row, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Code"
                                                                    value={row.code}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "code", e.target.value)
                                                                    }
                                                                    name="code[1,2,3,5]"
                                                                />
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    placeholder="Enter Guarantee Codes"
                                                                    value={row.name}
                                                                    onChange={(e) =>
                                                                        handleChange(index, "name", e.target.value)
                                                                    }
                                                                />
                                                            </td>
                                                            <td className="text-center">
                                                                {index !== 0 && (
                                                                    <button
                                                                        className="btn btn-sm text-danger fs-6"
                                                                        onClick={() => handleDeleteRow(index)}
                                                                    >
                                                                        <i className="fas fa-trash"></i>
                                                                    </button>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <div className="text-end">
                                                <button className="btn btn-sm btn-primary" onClick={handleAddRow}>
                                                    Add
                                                </button>
                                            </div>
                                        </div>

                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-info waves-effect waves-light"
                                                onClick={handleSubmit}
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            {/* /.modal */}

                            {/* update Business */}
                            <div
                                id="Update-Business-Source"
                                className="modal fade"
                                tabIndex={-1}
                                role="dialog"
                                aria-hidden="true"
                            >
                                <div className="modal-dialog">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">Update Guarantee Codes</h4>
                                            <button
                                                type="button"
                                                className="btn-close"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                            />
                                        </div>

                                        <div className="modal-body" >
                                            <div className="mb-3">
                                                <label className="form-label">Code</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editData.Code}
                                                    onChange={(e) => setEditData({ ...editData, Code: e.target.value })}
                                                />
                                            </div>

                                            <div className="mb-3">
                                                <label className="form-label">Guarantee Codes</label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    value={editData.guaranteeCodes}
                                                    onChange={(e) => setEditData({ ...editData, guaranteeCodes: e.target.value })}
                                                />
                                            </div>

                                        </div>

                                        <div className="modal-footer">
                                            <button
                                                type="button"
                                                className="btn btn-info waves-effect waves-light"
                                                onClick={handleUpdate}
                                            >
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
